import { generateUUID } from "../helper";
export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const BM = editor.BlockManager;

    const TYPE = DOMC.getType('C-SELECT');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    var model = MODEL.extend({

        defaults:{
            ...MODEL.prototype.defaults,
            tagName:"SELECT",
            attributes:{
                'data-slg-type':'C-SELECT-MONTH',
                name:"month",
                placeholder:'Month'
            },
            options:["Jenuary","February","March","April","May","June","July","Augunst","September","October","November","December"],
            format:'text', // or 'number'
            traits: [
                /* {
                    type:'select',
                    changeProp: 1,
                    label:'Format',
                    name:'format',
                    options:[
                        {id:'text', name:'Text'},
                        {id:'number', name:'Number'}
                    ]
                } */
            ].concat(MODEL.prototype.defaults.traits)
          
        },
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-SELECT-MONTH")
                    return { type:'C-SELECT-MONTH' }
        }
    });

    var view = VIEW.extend({
        init: function () {  

            let model = this.model;
            this.listenTo(model, 'change:attributes:placeholder', this.updatePlaceholder);
            // this.listenTo(model,'change:format', this.changeFormat);
        },

        changeFormat: function(){
            this.formatOptions();
            this.renderOptions();
        },
        
        formatOptions:function(){
            let options = this.model.get('options');
            let format = this.model.get('format');
            switch (format) {
                case 'number':
                    options = options.map((option,index)=>{
                        let label = index + 1;
                        let value = index + 1;
                        let key = (option.key) ? option.key : generateUUID()
                        return {
                            label,
                            value,
                            key
                        }
                    });
                    break;
                case 'text':
                    options = options.map((option,index)=>{
                        let label = (option.label) ? option.label : option;
                        let value = (option.value) ? option.value : option;
                        let key = (option.key) ? option.key : generateUUID()
                        return {
                            label,
                            value,
                            key
                        }
                    });
                default:
                    break;
            }
            
            this.model.set('options',options);
        }
    });

    DOMC.addType('C-SELECT-MONTH', {
      model:model,
      view:view,
    });

    /* bm.add('B-SELECT-MONTH', {
        label: `
                <p class="b-text-label mt-3">MONTH</p>
              `,
        content: { 
          type: 'C-SELECT-MONTH',
         },
        // media: '<svg>...</svg>',
    }); */
};
  